import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "@components/Link"
import { useGetLink } from "@hooks/useURL"
import { FluidImage, BackgroundFluidImage } from "@components/Image"
import { Svg } from "@components/Svg"
import * as Animations from "@components/Animations"
import * as css from "@css/components/blocks/index/Long.module.styl"

export default function Long()
{
    const q = useStaticQuery(graphql`
        query {
            bg : file(relativePath: { eq: "IndexLong__img__bg@2x.jpg" }) { childImageSharp { fluid(maxWidth: 1440) {
                ...GatsbyImageSharpFluid
            }}}
            b : file(relativePath: { eq: "Common__img__b.svg" }) { publicURL }
            title : file(relativePath: { eq: "IndexLong__lbl__long.svg" }) { publicURL }
            bestrong : file(relativePath: { eq: "Common__lbl__be-strong.svg" }) { publicURL }
            border : file(relativePath: { eq: "Common__img__border.svg" }) { publicURL }
        }
    `)
    const containerRef = React.useRef()
    return(
        <section className={css.container} ref={containerRef}>
            <div className={css.inner}>
                <figure className={css.imageA}>
                    <Animations.PraraxImage container={containerRef} className={css.imageInner}>
                        <FluidImage data={q.bg} />
                        {/* <img src={q.bg.childImageSharp.fluid.src}/> */}
                    </Animations.PraraxImage>
                </figure>
                <div className={css.contentA}>
                    <div className={css.right}>
                        <div className={css.deco}>
                            <Animations.FadeIn className={css.label_best}>
                                <img src={q.title.publicURL} alt='BEST' />
                            </Animations.FadeIn>
                            <div className={css.border}>
                                <img src={q.border.publicURL} />
                            </div>
                            <Animations.FadeIn className={css.bestrong}>
                                <img src={q.bestrong.publicURL} alt='BE-STRONG' />
                            </Animations.FadeIn>
                        </div>
                    </div>
                    <div className={css.left}>
                        <Animations.FadeIn>
                            <div className={css.paragraph}>
                                <Animations.FadeIn2 className={css.b}>
                                    <img src={q.b.publicURL} />
                                </Animations.FadeIn2>
                                <h2 className={css.title}>
                                    ユーザーのワークタイムを快適に、快調に。最高の手応えを感じられるビジネスシーンの構築をベストロングと考え創りだそう。
                                </h2>
                                <p className={css.text}>
                                    次の一歩を歩み出したい、そう考える企業をベストロングは応援します。働き方が変化するビジネスシーンのプロダクト形成にベストロングは伴走し、お客様とモノ創りにチャレンジします。お客様にとって今まで以上にエネルギッシュで有益な商品を私たちは提供していきます。実現できるよう私たちはチャレンジします。
                                </p>
                            </div>
                        </Animations.FadeIn>
                    </div>
                </div>
            </div>
        </section>
    )
}
